export const AUTH_PATH = 'auth';
export const I18N_ASSETS_PATH = 'assets/i18n';
export const CONFIGS_PATH = '/configs/';
export const HEALTH_CHECK_PATH = 'health-check';
